import React, { useEffect, useState } from 'react';
import { Button, Table, Header, Toast } from 'react-frontier';
import { useParams, useNavigate } from 'react-router-dom';
import { InvitationInfo } from '../Classes';
import { useTitle } from '../Hooks';
import { addCommas } from '@tempu/components/Util';
import { getPayRateTypeLocale } from '../Util';

import moment from 'moment';
import API from '../API';

var UserPostingInvite = ()=>{
	var navigate = useNavigate();
   var params = useParams<{ job_id: string }>();
   var job_id = parseInt(params?.job_id);
   var { setTitle } = useTitle();
   var [loadError, setLoadError] = useState<string>(null);
	var [invitationInfo, setInvitationInfo] = useState<InvitationInfo>(null);
	var [loading, setLoading] = useState<boolean>(false);

	useEffect(()=>{
		setTitle('Invitación de puesto');
      API.getInvitation(job_id).then(res=>{
			if(res.error) return setLoadError(res.message);
			setInvitationInfo(res.data);
		}).catch(err=>{
			return setLoadError('Hubo un error inesperado cargando la información de la invitaci+on. (LCL-1)');
		})
	}, []);

	var response = async(r: boolean)=>{
		setLoading(true);
		API.invitationResponse(job_id, r).then(res=>{
			if(res.error) return Toast.error(res.message);
			Toast.success(r ? 'Invitación aceptada!' : 'Invitación rechazada!')
			return navigate(`/postings`);
		}).catch(err=>{
			return Toast.error('Hubo un error inesperado con el sistema. (LCL-1)');
		}).finally(()=>{
			setLoading(false);
		})
	}

	if(loadError){
		return <Header text='Error' subtext={loadError} />
	}
	
	if(!invitationInfo){
		return <Header text='Cargando datos' loading />
	}

	return <div className='tp user-posting-invite-screen'>
      <Table 
			title='Información'
			striped
			details
			style={{ margin: 'auto', maxWidth: 500 }}
			actions={<>
				<Button text='Rechazar' color='red' basic onClick={()=> response(false)}/>
				<Button text='Aceptar' color='green' onClick={()=> response(true)}/>
			</>}
			data={[
				['Empresa', invitationInfo.business_name],
				['Empleo', invitationInfo.posting_name],
				['Invitado por', invitationInfo.inviter_name],
				['Puesto', invitationInfo.job_name],
				['Sueldo', '$' +addCommas(invitationInfo.pay_rate)],
				['Frecuencia', getPayRateTypeLocale(invitationInfo.rate_type)],
				['Inicio', moment.unix(invitationInfo.job_start_date).format('DD/MMM/YY HH:mm')],
				['Fin', moment.unix(invitationInfo.job_end_date).format('DD/MMM/YY HH:mm')],
				['Descripción', invitationInfo.job_description],
			]}
		/>
	</div>
}

export default UserPostingInvite;